/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetUserResponse,
  EditUserResponse,
  EditUserRequest,
  Get2faStatusResponse,
  Toggle2faRequest,
  Verify2faResponse,
  Verify2faRequest,
  VerifyUserMobileNoBySMSResponse,
  VerifyUserMobileNoBySMSRequest,
  VerifySMSCodeResponse,
  VerifySMSCodeRequest,
  GetAuthHistoryResponse,
  UtxUsersGetHistoryParams,
  Get2faSMSResponse,
  UploadDocumentResponse,
  UtxUsersUploadDocumentBody,
  ResetPasswordResponse,
  ResetPasswordRequest,
  GetUserSecurityResponse,
  GetUserProfileResponse,
  UserChangePasswordResponse,
  UserChangePasswordRequest,
  PostUserPhoneNumberResponse,
  PostUserPhoneNumberRequest,
  PatchUserPhoneNumberResponse,
  PatchUserPhoneNumberRequest,
  OTPForNewPhoneNumberResponse,
  OTPForNewPhoneNumberRequest,
  GetUserTrustResponse,
  UtxUsersGetUserTrustParams,
  UpdateBeneficiariesResponse,
  UpdateBeneficiariesRequest,
  UpdateMetadataResponse,
  UpdateMetadataRequest,
  SetDefaultCurrencyResponse,
  SetDefaultCurrencyRequest,
  GetLoginTfaEnabledResponse,
  EnabledLoginTfaResponse,
  EnabledLoginTfaRequest,
  StatementOptionsResponse,
  StatementOptionsRequest,
  AddAntiPhishingCodeResponse,
  AddAntiPhishingCodeRequest,
  UpdateAntiPhishingCodeResponse,
  UpdateAntiPhishingCodeRequest,
  GetApprovedAgreementsResponse,
  GetUserDocumentResponse,
  GetDownloadDocumentsResponse,
  UtxUsersDownloadDocumentParams,
  UpdateReferralCodeResponse,
  UpdateReferralCodeRequest,
  UpdateUserNewAppExperienceResponse,
  UpdateUserNewAppExperienceRequest
} from './schema'



/**
 * To get user details
 */
export const utxUsersGetUser = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserResponse>> => {
    return axios.get(
      `/users`,options
    );
  }


export const getUtxUsersGetUserQueryKey = () => [`/users`];

    
export type UtxUsersGetUserQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetUser>>>
export type UtxUsersGetUserQueryError = AxiosError<unknown>

export const useUtxUsersGetUser = <TData = Awaited<ReturnType<typeof utxUsersGetUser>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetUserQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetUser>>> = ({ signal }) => utxUsersGetUser({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Update user profile with selected fields, only included those fields that need to be updated
 */
export const utxUsersPatchUser = (
    editUserRequest: EditUserRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EditUserResponse>> => {
    return axios.patch(
      `/users`,
      editUserRequest,options
    );
  }



    export type UtxUsersPatchUserMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersPatchUser>>>
    export type UtxUsersPatchUserMutationBody = EditUserRequest
    export type UtxUsersPatchUserMutationError = AxiosError<unknown>

    export const useUtxUsersPatchUser = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersPatchUser>>, TError,{data: EditUserRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersPatchUser>>, {data: EditUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersPatchUser(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersPatchUser>>, TError, {data: EditUserRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get user's 2FA status, enabled or not
 */
export const utxUsersGet2faStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Get2faStatusResponse>> => {
    return axios.get(
      `/users/2fa`,options
    );
  }


export const getUtxUsersGet2faStatusQueryKey = () => [`/users/2fa`];

    
export type UtxUsersGet2faStatusQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGet2faStatus>>>
export type UtxUsersGet2faStatusQueryError = AxiosError<unknown>

export const useUtxUsersGet2faStatus = <TData = Awaited<ReturnType<typeof utxUsersGet2faStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGet2faStatus>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGet2faStatusQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGet2faStatus>>> = ({ signal }) => utxUsersGet2faStatus({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGet2faStatus>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Update user's 2FA status, turn on and off
 */
export const utxUsersToggle2Fa = (
    toggle2faRequest: Toggle2faRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/users/2fa/toggle`,
      toggle2faRequest,options
    );
  }



    export type UtxUsersToggle2FaMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersToggle2Fa>>>
    export type UtxUsersToggle2FaMutationBody = Toggle2faRequest
    export type UtxUsersToggle2FaMutationError = AxiosError<unknown>

    export const useUtxUsersToggle2Fa = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersToggle2Fa>>, TError,{data: Toggle2faRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersToggle2Fa>>, {data: Toggle2faRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersToggle2Fa(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersToggle2Fa>>, TError, {data: Toggle2faRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Verify 2FA token
 */
export const utxUsersVerify2Fa = (
    verify2faRequest: Verify2faRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Verify2faResponse>> => {
    return axios.post(
      `/users/2fa/verify`,
      verify2faRequest,options
    );
  }



    export type UtxUsersVerify2FaMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersVerify2Fa>>>
    export type UtxUsersVerify2FaMutationBody = Verify2faRequest
    export type UtxUsersVerify2FaMutationError = AxiosError<unknown>

    export const useUtxUsersVerify2Fa = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersVerify2Fa>>, TError,{data: Verify2faRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersVerify2Fa>>, {data: Verify2faRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersVerify2Fa(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersVerify2Fa>>, TError, {data: Verify2faRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Verify 2FA token
 */
export const utxUsersVerify2FaV2 = (
    verify2faRequest: Verify2faRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Verify2faResponse>> => {
    return axios.post(
      `/users/2fa/verify-v2`,
      verify2faRequest,options
    );
  }



    export type UtxUsersVerify2FaV2MutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersVerify2FaV2>>>
    export type UtxUsersVerify2FaV2MutationBody = Verify2faRequest
    export type UtxUsersVerify2FaV2MutationError = AxiosError<unknown>

    export const useUtxUsersVerify2FaV2 = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersVerify2FaV2>>, TError,{data: Verify2faRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersVerify2FaV2>>, {data: Verify2faRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersVerify2FaV2(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersVerify2FaV2>>, TError, {data: Verify2faRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxUsersVerifyUserMobileNoBySMS = (
    verifyUserMobileNoBySMSRequest: VerifyUserMobileNoBySMSRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<VerifyUserMobileNoBySMSResponse>> => {
    return axios.post(
      `/users/verify-mobile`,
      verifyUserMobileNoBySMSRequest,options
    );
  }



    export type UtxUsersVerifyUserMobileNoBySMSMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersVerifyUserMobileNoBySMS>>>
    export type UtxUsersVerifyUserMobileNoBySMSMutationBody = VerifyUserMobileNoBySMSRequest
    export type UtxUsersVerifyUserMobileNoBySMSMutationError = AxiosError<unknown>

    export const useUtxUsersVerifyUserMobileNoBySMS = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersVerifyUserMobileNoBySMS>>, TError,{data: VerifyUserMobileNoBySMSRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersVerifyUserMobileNoBySMS>>, {data: VerifyUserMobileNoBySMSRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersVerifyUserMobileNoBySMS(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersVerifyUserMobileNoBySMS>>, TError, {data: VerifyUserMobileNoBySMSRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Verify user sms code
 */
export const utxUsersCheckSMSVerificationCode = (
    verifySMSCodeRequest: VerifySMSCodeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<VerifySMSCodeResponse>> => {
    return axios.post(
      `/users/verify-mobile/verify-code`,
      verifySMSCodeRequest,options
    );
  }



    export type UtxUsersCheckSMSVerificationCodeMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersCheckSMSVerificationCode>>>
    export type UtxUsersCheckSMSVerificationCodeMutationBody = VerifySMSCodeRequest
    export type UtxUsersCheckSMSVerificationCodeMutationError = AxiosError<unknown>

    export const useUtxUsersCheckSMSVerificationCode = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersCheckSMSVerificationCode>>, TError,{data: VerifySMSCodeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersCheckSMSVerificationCode>>, {data: VerifySMSCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersCheckSMSVerificationCode(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersCheckSMSVerificationCode>>, TError, {data: VerifySMSCodeRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get user's history
 */
export const utxUsersGetHistory = (
    params?: UtxUsersGetHistoryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAuthHistoryResponse[]>> => {
    return axios.get(
      `/users/getHistory`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxUsersGetHistoryQueryKey = (params?: UtxUsersGetHistoryParams,) => [`/users/getHistory`, ...(params ? [params]: [])];

    
export type UtxUsersGetHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetHistory>>>
export type UtxUsersGetHistoryQueryError = AxiosError<unknown>

export const useUtxUsersGetHistory = <TData = Awaited<ReturnType<typeof utxUsersGetHistory>>, TError = AxiosError<unknown>>(
 params?: UtxUsersGetHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetHistory>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetHistoryQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetHistory>>> = ({ signal }) => utxUsersGetHistory(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetHistory>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get user's 2FA sms code
 */
export const utxUsersGet2faSms = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Get2faSMSResponse>> => {
    return axios.get(
      `/users/get2faCode`,options
    );
  }


export const getUtxUsersGet2faSmsQueryKey = () => [`/users/get2faCode`];

    
export type UtxUsersGet2faSmsQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGet2faSms>>>
export type UtxUsersGet2faSmsQueryError = AxiosError<unknown>

export const useUtxUsersGet2faSms = <TData = Awaited<ReturnType<typeof utxUsersGet2faSms>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGet2faSms>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGet2faSmsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGet2faSms>>> = ({ signal }) => utxUsersGet2faSms({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGet2faSms>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxUsersUploadDocument = (
    utxUsersUploadDocumentBody: UtxUsersUploadDocumentBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UploadDocumentResponse>> => {const formData = new FormData();
if(utxUsersUploadDocumentBody.file !== undefined) {
 formData.append('file', utxUsersUploadDocumentBody.file)
 }

    return axios.post(
      `/users/document-upload`,
      formData,options
    );
  }



    export type UtxUsersUploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUploadDocument>>>
    export type UtxUsersUploadDocumentMutationBody = UtxUsersUploadDocumentBody
    export type UtxUsersUploadDocumentMutationError = AxiosError<unknown>

    export const useUtxUsersUploadDocument = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUploadDocument>>, TError,{data: UtxUsersUploadDocumentBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUploadDocument>>, {data: UtxUsersUploadDocumentBody}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUploadDocument(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUploadDocument>>, TError, {data: UtxUsersUploadDocumentBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Change Password
 */
export const utxUsersResetPassword = (
    resetPasswordRequest: ResetPasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ResetPasswordResponse>> => {
    return axios.post(
      `/users/reset-password`,
      resetPasswordRequest,options
    );
  }



    export type UtxUsersResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersResetPassword>>>
    export type UtxUsersResetPasswordMutationBody = ResetPasswordRequest
    export type UtxUsersResetPasswordMutationError = AxiosError<unknown>

    export const useUtxUsersResetPassword = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersResetPassword>>, TError,{data: ResetPasswordRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersResetPassword>>, {data: ResetPasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersResetPassword(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersResetPassword>>, TError, {data: ResetPasswordRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * get user security setting
 */
export const utxUsersGetUserSecuritySetting = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserSecurityResponse>> => {
    return axios.get(
      `/user/security`,options
    );
  }


export const getUtxUsersGetUserSecuritySettingQueryKey = () => [`/user/security`];

    
export type UtxUsersGetUserSecuritySettingQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetUserSecuritySetting>>>
export type UtxUsersGetUserSecuritySettingQueryError = AxiosError<unknown>

export const useUtxUsersGetUserSecuritySetting = <TData = Awaited<ReturnType<typeof utxUsersGetUserSecuritySetting>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetUserSecuritySetting>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetUserSecuritySettingQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetUserSecuritySetting>>> = ({ signal }) => utxUsersGetUserSecuritySetting({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetUserSecuritySetting>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * get user profile
 */
export const utxUsersGetUserProfile = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserProfileResponse>> => {
    return axios.get(
      `/user/profile`,options
    );
  }


export const getUtxUsersGetUserProfileQueryKey = () => [`/user/profile`];

    
export type UtxUsersGetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetUserProfile>>>
export type UtxUsersGetUserProfileQueryError = AxiosError<unknown>

export const useUtxUsersGetUserProfile = <TData = Awaited<ReturnType<typeof utxUsersGetUserProfile>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetUserProfile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetUserProfileQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetUserProfile>>> = ({ signal }) => utxUsersGetUserProfile({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetUserProfile>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * user can change password
 */
export const utxUsersChangePassword = (
    userChangePasswordRequest: UserChangePasswordRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserChangePasswordResponse>> => {
    return axios.post(
      `/user/change-password`,
      userChangePasswordRequest,options
    );
  }



    export type UtxUsersChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersChangePassword>>>
    export type UtxUsersChangePasswordMutationBody = UserChangePasswordRequest
    export type UtxUsersChangePasswordMutationError = AxiosError<unknown>

    export const useUtxUsersChangePassword = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersChangePassword>>, TError,{data: UserChangePasswordRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersChangePassword>>, {data: UserChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersChangePassword(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersChangePassword>>, TError, {data: UserChangePasswordRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * User can add phone no., OTP Requirement: SMS
 */
export const utxUsersAddPhoneNumber = (
    postUserPhoneNumberRequest: PostUserPhoneNumberRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostUserPhoneNumberResponse>> => {
    return axios.post(
      `/user/phone-number`,
      postUserPhoneNumberRequest,options
    );
  }



    export type UtxUsersAddPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersAddPhoneNumber>>>
    export type UtxUsersAddPhoneNumberMutationBody = PostUserPhoneNumberRequest
    export type UtxUsersAddPhoneNumberMutationError = AxiosError<unknown>

    export const useUtxUsersAddPhoneNumber = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersAddPhoneNumber>>, TError,{data: PostUserPhoneNumberRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersAddPhoneNumber>>, {data: PostUserPhoneNumberRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersAddPhoneNumber(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersAddPhoneNumber>>, TError, {data: PostUserPhoneNumberRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * User can change phone no., OTP Requirement: SMS + email or google
 */
export const utxUsersChangePhoneNumber = (
    patchUserPhoneNumberRequest: PatchUserPhoneNumberRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PatchUserPhoneNumberResponse>> => {
    return axios.patch(
      `/user/phone-number`,
      patchUserPhoneNumberRequest,options
    );
  }



    export type UtxUsersChangePhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersChangePhoneNumber>>>
    export type UtxUsersChangePhoneNumberMutationBody = PatchUserPhoneNumberRequest
    export type UtxUsersChangePhoneNumberMutationError = AxiosError<unknown>

    export const useUtxUsersChangePhoneNumber = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersChangePhoneNumber>>, TError,{data: PatchUserPhoneNumberRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersChangePhoneNumber>>, {data: PatchUserPhoneNumberRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersChangePhoneNumber(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersChangePhoneNumber>>, TError, {data: PatchUserPhoneNumberRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * User request OTP for adding or changing their phone number.
 */
export const utxUsersRequestOTPForNewPhoneNumber = (
    oTPForNewPhoneNumberRequest: OTPForNewPhoneNumberRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OTPForNewPhoneNumberResponse>> => {
    return axios.post(
      `/user/request-otp-for-new-phone-number`,
      oTPForNewPhoneNumberRequest,options
    );
  }



    export type UtxUsersRequestOTPForNewPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersRequestOTPForNewPhoneNumber>>>
    export type UtxUsersRequestOTPForNewPhoneNumberMutationBody = OTPForNewPhoneNumberRequest
    export type UtxUsersRequestOTPForNewPhoneNumberMutationError = AxiosError<void>

    export const useUtxUsersRequestOTPForNewPhoneNumber = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersRequestOTPForNewPhoneNumber>>, TError,{data: OTPForNewPhoneNumberRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersRequestOTPForNewPhoneNumber>>, {data: OTPForNewPhoneNumberRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersRequestOTPForNewPhoneNumber(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersRequestOTPForNewPhoneNumber>>, TError, {data: OTPForNewPhoneNumberRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * get user trust
 */
export const utxUsersGetUserTrust = (
    params: UtxUsersGetUserTrustParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserTrustResponse>> => {
    return axios.get(
      `/user/trust-info`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxUsersGetUserTrustQueryKey = (params: UtxUsersGetUserTrustParams,) => [`/user/trust-info`, ...(params ? [params]: [])];

    
export type UtxUsersGetUserTrustQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetUserTrust>>>
export type UtxUsersGetUserTrustQueryError = AxiosError<unknown>

export const useUtxUsersGetUserTrust = <TData = Awaited<ReturnType<typeof utxUsersGetUserTrust>>, TError = AxiosError<unknown>>(
 params: UtxUsersGetUserTrustParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetUserTrust>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetUserTrustQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetUserTrust>>> = ({ signal }) => utxUsersGetUserTrust(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetUserTrust>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Update user beneficiaries
 */
export const utxUsersUpdateBeneficiaries = (
    updateBeneficiariesRequest: UpdateBeneficiariesRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateBeneficiariesResponse>> => {
    return axios.post(
      `/user/update-beneficiaries`,
      updateBeneficiariesRequest,options
    );
  }



    export type UtxUsersUpdateBeneficiariesMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUpdateBeneficiaries>>>
    export type UtxUsersUpdateBeneficiariesMutationBody = UpdateBeneficiariesRequest
    export type UtxUsersUpdateBeneficiariesMutationError = AxiosError<unknown>

    export const useUtxUsersUpdateBeneficiaries = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUpdateBeneficiaries>>, TError,{data: UpdateBeneficiariesRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUpdateBeneficiaries>>, {data: UpdateBeneficiariesRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUpdateBeneficiaries(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUpdateBeneficiaries>>, TError, {data: UpdateBeneficiariesRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Update user metadata navDefaultCurrency
 */
export const utxUsersUpdateMetadata = (
    updateMetadataRequest: UpdateMetadataRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateMetadataResponse>> => {
    return axios.post(
      `/user/metadata`,
      updateMetadataRequest,options
    );
  }



    export type UtxUsersUpdateMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUpdateMetadata>>>
    export type UtxUsersUpdateMetadataMutationBody = UpdateMetadataRequest
    export type UtxUsersUpdateMetadataMutationError = AxiosError<unknown>

    export const useUtxUsersUpdateMetadata = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUpdateMetadata>>, TError,{data: UpdateMetadataRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUpdateMetadata>>, {data: UpdateMetadataRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUpdateMetadata(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUpdateMetadata>>, TError, {data: UpdateMetadataRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * let user set default currency
 */
export const utxUsersPostUserDefaultCurrency = (
    setDefaultCurrencyRequest: SetDefaultCurrencyRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetDefaultCurrencyResponse>> => {
    return axios.post(
      `/user/set-default-currency`,
      setDefaultCurrencyRequest,options
    );
  }



    export type UtxUsersPostUserDefaultCurrencyMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersPostUserDefaultCurrency>>>
    export type UtxUsersPostUserDefaultCurrencyMutationBody = SetDefaultCurrencyRequest
    export type UtxUsersPostUserDefaultCurrencyMutationError = AxiosError<void>

    export const useUtxUsersPostUserDefaultCurrency = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersPostUserDefaultCurrency>>, TError,{data: SetDefaultCurrencyRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersPostUserDefaultCurrency>>, {data: SetDefaultCurrencyRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersPostUserDefaultCurrency(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersPostUserDefaultCurrency>>, TError, {data: SetDefaultCurrencyRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Check if TFA Authentication is enabled/disabled for this user
 */
export const utxUsersGetLoginTfaEnabled = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetLoginTfaEnabledResponse>> => {
    return axios.get(
      `/user/login-tfa`,options
    );
  }


export const getUtxUsersGetLoginTfaEnabledQueryKey = () => [`/user/login-tfa`];

    
export type UtxUsersGetLoginTfaEnabledQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetLoginTfaEnabled>>>
export type UtxUsersGetLoginTfaEnabledQueryError = AxiosError<void>

export const useUtxUsersGetLoginTfaEnabled = <TData = Awaited<ReturnType<typeof utxUsersGetLoginTfaEnabled>>, TError = AxiosError<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetLoginTfaEnabled>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetLoginTfaEnabledQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetLoginTfaEnabled>>> = ({ signal }) => utxUsersGetLoginTfaEnabled({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetLoginTfaEnabled>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Turn on/off the TFA Authentication on login for this user
 */
export const utxUsersEnableLoginTfa = (
    enabledLoginTfaRequest: EnabledLoginTfaRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EnabledLoginTfaResponse>> => {
    return axios.post(
      `/user/login-tfa`,
      enabledLoginTfaRequest,options
    );
  }



    export type UtxUsersEnableLoginTfaMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersEnableLoginTfa>>>
    export type UtxUsersEnableLoginTfaMutationBody = EnabledLoginTfaRequest
    export type UtxUsersEnableLoginTfaMutationError = AxiosError<void>

    export const useUtxUsersEnableLoginTfa = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersEnableLoginTfa>>, TError,{data: EnabledLoginTfaRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersEnableLoginTfa>>, {data: EnabledLoginTfaRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersEnableLoginTfa(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersEnableLoginTfa>>, TError, {data: EnabledLoginTfaRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * User update statement options to view in pdf file.
 */
export const utxUsersUpdateStatementOptions = (
    statementOptionsRequest: StatementOptionsRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<StatementOptionsResponse>> => {
    return axios.post(
      `/user/update-statement-options`,
      statementOptionsRequest,options
    );
  }



    export type UtxUsersUpdateStatementOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUpdateStatementOptions>>>
    export type UtxUsersUpdateStatementOptionsMutationBody = StatementOptionsRequest
    export type UtxUsersUpdateStatementOptionsMutationError = AxiosError<void>

    export const useUtxUsersUpdateStatementOptions = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUpdateStatementOptions>>, TError,{data: StatementOptionsRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUpdateStatementOptions>>, {data: StatementOptionsRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUpdateStatementOptions(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUpdateStatementOptions>>, TError, {data: StatementOptionsRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Let user add anti phishing code
 */
export const utxUsersAddAntiPhishingCode = (
    addAntiPhishingCodeRequest: AddAntiPhishingCodeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AddAntiPhishingCodeResponse>> => {
    return axios.post(
      `/users/add-anti-phishing-code`,
      addAntiPhishingCodeRequest,options
    );
  }



    export type UtxUsersAddAntiPhishingCodeMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCode>>>
    export type UtxUsersAddAntiPhishingCodeMutationBody = AddAntiPhishingCodeRequest
    export type UtxUsersAddAntiPhishingCodeMutationError = AxiosError<unknown>

    export const useUtxUsersAddAntiPhishingCode = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCode>>, TError,{data: AddAntiPhishingCodeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCode>>, {data: AddAntiPhishingCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersAddAntiPhishingCode(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCode>>, TError, {data: AddAntiPhishingCodeRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Let user add anti phishing code
 */
export const utxUsersAddAntiPhishingCodeWithScope = (
    addAntiPhishingCodeRequest: AddAntiPhishingCodeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AddAntiPhishingCodeResponse>> => {
    return axios.post(
      `/users/add-anti-phishing-code-v2`,
      addAntiPhishingCodeRequest,options
    );
  }



    export type UtxUsersAddAntiPhishingCodeWithScopeMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCodeWithScope>>>
    export type UtxUsersAddAntiPhishingCodeWithScopeMutationBody = AddAntiPhishingCodeRequest
    export type UtxUsersAddAntiPhishingCodeWithScopeMutationError = AxiosError<unknown>

    export const useUtxUsersAddAntiPhishingCodeWithScope = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCodeWithScope>>, TError,{data: AddAntiPhishingCodeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCodeWithScope>>, {data: AddAntiPhishingCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersAddAntiPhishingCodeWithScope(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersAddAntiPhishingCodeWithScope>>, TError, {data: AddAntiPhishingCodeRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Let user update anti phishing code
 */
export const utxUsersUpdateAntiPhishingCode = (
    updateAntiPhishingCodeRequest: UpdateAntiPhishingCodeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateAntiPhishingCodeResponse>> => {
    return axios.post(
      `/users/update-anti-phishing-code`,
      updateAntiPhishingCodeRequest,options
    );
  }



    export type UtxUsersUpdateAntiPhishingCodeMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCode>>>
    export type UtxUsersUpdateAntiPhishingCodeMutationBody = UpdateAntiPhishingCodeRequest
    export type UtxUsersUpdateAntiPhishingCodeMutationError = AxiosError<unknown>

    export const useUtxUsersUpdateAntiPhishingCode = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCode>>, TError,{data: UpdateAntiPhishingCodeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCode>>, {data: UpdateAntiPhishingCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUpdateAntiPhishingCode(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCode>>, TError, {data: UpdateAntiPhishingCodeRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Let user update anti phishing code
 */
export const utxUsersUpdateAntiPhishingCodeWithScope = (
    updateAntiPhishingCodeRequest: UpdateAntiPhishingCodeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateAntiPhishingCodeResponse>> => {
    return axios.post(
      `/users/update-anti-phishing-code-v2`,
      updateAntiPhishingCodeRequest,options
    );
  }



    export type UtxUsersUpdateAntiPhishingCodeWithScopeMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCodeWithScope>>>
    export type UtxUsersUpdateAntiPhishingCodeWithScopeMutationBody = UpdateAntiPhishingCodeRequest
    export type UtxUsersUpdateAntiPhishingCodeWithScopeMutationError = AxiosError<unknown>

    export const useUtxUsersUpdateAntiPhishingCodeWithScope = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCodeWithScope>>, TError,{data: UpdateAntiPhishingCodeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCodeWithScope>>, {data: UpdateAntiPhishingCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUpdateAntiPhishingCodeWithScope(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUpdateAntiPhishingCodeWithScope>>, TError, {data: UpdateAntiPhishingCodeRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxUsersGetApprovedAgreements = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetApprovedAgreementsResponse[]>> => {
    return axios.get(
      `/users/agreements`,options
    );
  }


export const getUtxUsersGetApprovedAgreementsQueryKey = () => [`/users/agreements`];

    
export type UtxUsersGetApprovedAgreementsQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetApprovedAgreements>>>
export type UtxUsersGetApprovedAgreementsQueryError = AxiosError<unknown>

export const useUtxUsersGetApprovedAgreements = <TData = Awaited<ReturnType<typeof utxUsersGetApprovedAgreements>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetApprovedAgreements>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetApprovedAgreementsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetApprovedAgreements>>> = ({ signal }) => utxUsersGetApprovedAgreements({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetApprovedAgreements>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxUsersGetUserDocument = (
    clientDocumentId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserDocumentResponse>> => {
    return axios.get(
      `/documents/${clientDocumentId}`,options
    );
  }


export const getUtxUsersGetUserDocumentQueryKey = (clientDocumentId: string,) => [`/documents/${clientDocumentId}`];

    
export type UtxUsersGetUserDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersGetUserDocument>>>
export type UtxUsersGetUserDocumentQueryError = AxiosError<unknown>

export const useUtxUsersGetUserDocument = <TData = Awaited<ReturnType<typeof utxUsersGetUserDocument>>, TError = AxiosError<unknown>>(
 clientDocumentId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersGetUserDocument>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersGetUserDocumentQueryKey(clientDocumentId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersGetUserDocument>>> = ({ signal }) => utxUsersGetUserDocument(clientDocumentId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersGetUserDocument>>, TError, TData>(queryKey, queryFn, {enabled: !!(clientDocumentId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxUsersDownloadDocument = (
    params: UtxUsersDownloadDocumentParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetDownloadDocumentsResponse>> => {
    return axios.get(
      `/users/download`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxUsersDownloadDocumentQueryKey = (params: UtxUsersDownloadDocumentParams,) => [`/users/download`, ...(params ? [params]: [])];

    
export type UtxUsersDownloadDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof utxUsersDownloadDocument>>>
export type UtxUsersDownloadDocumentQueryError = AxiosError<unknown>

export const useUtxUsersDownloadDocument = <TData = Awaited<ReturnType<typeof utxUsersDownloadDocument>>, TError = AxiosError<unknown>>(
 params: UtxUsersDownloadDocumentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxUsersDownloadDocument>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxUsersDownloadDocumentQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxUsersDownloadDocument>>> = ({ signal }) => utxUsersDownloadDocument(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxUsersDownloadDocument>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Let user update referral code
 */
export const utxUsersUpdateReferralCode = (
    updateReferralCodeRequest: UpdateReferralCodeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateReferralCodeResponse>> => {
    return axios.post(
      `/users/referral-code`,
      updateReferralCodeRequest,options
    );
  }



    export type UtxUsersUpdateReferralCodeMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUpdateReferralCode>>>
    export type UtxUsersUpdateReferralCodeMutationBody = UpdateReferralCodeRequest
    export type UtxUsersUpdateReferralCodeMutationError = AxiosError<unknown>

    export const useUtxUsersUpdateReferralCode = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUpdateReferralCode>>, TError,{data: UpdateReferralCodeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUpdateReferralCode>>, {data: UpdateReferralCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUpdateReferralCode(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUpdateReferralCode>>, TError, {data: UpdateReferralCodeRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Let user update new app experience
 */
export const utxUsersUpdateUserNewAppExperience = (
    updateUserNewAppExperienceRequest: UpdateUserNewAppExperienceRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateUserNewAppExperienceResponse>> => {
    return axios.post(
      `/users/new-app-experience`,
      updateUserNewAppExperienceRequest,options
    );
  }



    export type UtxUsersUpdateUserNewAppExperienceMutationResult = NonNullable<Awaited<ReturnType<typeof utxUsersUpdateUserNewAppExperience>>>
    export type UtxUsersUpdateUserNewAppExperienceMutationBody = UpdateUserNewAppExperienceRequest
    export type UtxUsersUpdateUserNewAppExperienceMutationError = AxiosError<unknown>

    export const useUtxUsersUpdateUserNewAppExperience = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxUsersUpdateUserNewAppExperience>>, TError,{data: UpdateUserNewAppExperienceRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxUsersUpdateUserNewAppExperience>>, {data: UpdateUserNewAppExperienceRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxUsersUpdateUserNewAppExperience(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxUsersUpdateUserNewAppExperience>>, TError, {data: UpdateUserNewAppExperienceRequest}, TContext>(mutationFn, mutationOptions)
    }
    